var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C26.627 44.0034 29.2287 43.4876 31.6556 42.4823C34.0826 41.477 36.2869 40.002 38.142 38.142C40.002 36.2869 41.477 34.0826 42.4823 31.6556C43.4876 29.2287 44.0034 26.627 44 24C44.0034 21.3731 43.4876 18.7714 42.4823 16.3444C41.4769 13.9175 40.0019 11.7131 38.142 9.85802C36.2869 7.99804 34.0826 6.52302 31.6556 5.5177C29.2287 4.51239 26.627 3.99661 24 4.00002C21.3731 3.99667 18.7714 4.51247 16.3444 5.51778C13.9175 6.52309 11.7131 7.99809 9.85802 9.85802C7.99809 11.7131 6.52309 13.9175 5.51778 16.3444C4.51247 18.7714 3.99667 21.3731 4.00002 24C3.99661 26.627 4.51239 29.2287 5.5177 31.6556C6.52302 34.0826 7.99804 36.2869 9.85802 38.142C11.7131 40.0019 13.9175 41.4769 16.3444 42.4823C18.7714 43.4876 21.3731 44.0034 24 44Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24L22 30L34 18",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d44c2d794578b2a567375ebfde6f16a1.svg";
export { ForwardRef as ReactComponent };